var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DrawablePhotoV1OrV2',{attrs:{"image":_vm.imageObject,"drawing":_vm.drawing,"width":480,"height":240,"show-thumbnail":false,"colors":[{ color: '#000000', marker: '#ffffff' }],"title":_vm.$t('Sign here'),"remove-button-title":_vm.$t('Remove signature'),"can-be-deleted":false},on:{"change":_vm.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }